var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14286 0C1.85781 0 0 1.92188 0 4.28571V25.7143C0 28.0781 1.85781 30 4.14286 30H10.4996V20.2366H7.0817V15H10.4996V12.7433C10.4996 6.91071 13.05 4.20536 18.5911 4.20536C19.6397 4.20536 21.4522 4.41964 22.1967 4.63393V9.375C21.8083 9.33482 21.1286 9.30804 20.2806 9.30804C17.5618 9.30804 16.5132 10.3728 16.5132 13.1384V15H21.9248L20.9926 20.2366H16.5067V30H24.8571C27.1422 30 29 28.0781 29 25.7143V4.28571C29 1.92188 27.1422 0 24.8571 0H4.14286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFac);
export default __webpack_public_path__ + "static/media/ic_fac.3a3da93d33685ce50e33578b77e701ba.svg";
export { ForwardRef as ReactComponent };